module.exports = __webpack_public_path__ + "img/right-arrow.1b9ae0c0.svg";